export default __webpack_public_path__ + "static/media/04.1af24da2.png";